// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pui-lightbox__lightbox {\n  max-width: 95vw !important;\n}\n.completeness-check-modal__header {\n  display: flex;\n  align-items: center;\n  gap: 3.2rem;\n}\n.completeness-check-modal__loader {\n  min-width: 50rem;\n}\n.completeness-check-modal__tabs {\n  margin-top: 1rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
